<template>

    <div class="ensure-reservation ml-4">
        <div id="booking-notice">
            <img src="https://3.cdnpt.com/images/padlock-icon.png">
            <h3>{{__('messages.secure_your_reservation2')}}</h3>
            <p v-html="__('messages.add_your_info_text')"></p>
        </div>
    </div>

</template>

<script>


export default {
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    },
    methods: {

    },
    components: {

    }
}
</script>
